import * as React from "react";
import {  useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import {  useForm, FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AddNotes from "./AddNotes";
import dayjs from "dayjs";
import {  searchNoteAction } from "../../redux/actions/noteActions";
import AddNotesTable from "./AddNotesTable";
import AddNoteButton from "./AddNoteButton";
import { parseDate, getLocalTimeZone } from '@internationalized/date';
import DatePickerField from "../../common/DatePickerDashboard";
import { getSelectedCustomerList } from "../../redux/selectors/globalSearchSelectors";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
const poppinsFont = {
  fontFamily: '"Poppins", sans-serif',
};

const PoliciesList = ({
  getPolicyNumber,
  newpolicyId,
  customerId,
  selectedOption,
  selectedPolicyId,
  setSearchPerformed,

}) => {
  const [showNote, setShowNote] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [message, setMessage] = useState("");
  const selected_customer_list = useSelector(getSelectedCustomerList);
  const notesPolicyId = selectedPolicyId || null;
  // const [fromDate, setFromDate] = useState(dayjs().startOf('month'));
  // const [toDate, setToDate] = useState(dayjs());

  const notes = useSelector((state) => state.note.allNote);
  const searchNotes = useSelector((state) => state.note.searchNote);
  const dispatch = useDispatch();
  const methods = useForm();
  const {
    formState: { errors },
    reset,
  } = methods;

  const getToday = () => {
    const today = new Date();
    return parseDate(
      `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
    );
  };

  const getFirstOfMonth = () => {
    const today = new Date();
    return parseDate(
      `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-01`
    );
  };

  const formatForForm = (date) => {
    const d = date.toDate(getLocalTimeZone());
    return `${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}-${d.getFullYear()}`;
  };

  const initialFormData = {
    fromDate: formatForForm(getFirstOfMonth()),
    toDate: formatForForm(getToday()),
  };

  const [formData, setFormData] = useState(initialFormData);
  const [fieldErrors, setFieldErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});

  const handleDateChange = (fieldName, value) => {
    setFormData((prev) => ({ ...prev, [fieldName]: value }));
  };

  const handleBlur = (fieldName, errorMsg) => {
    setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
    setFieldErrors((prev) => ({ ...prev, [fieldName]: errorMsg }));
  };

  const handleClick = () => {
    setShowNote(true);
    setShowButton(true);
  };

const onSubmit = () => {
  if (!formData.fromDate && !formData.toDate && !message.trim()) {
    return;
  }

const formattedData = {
    fromDate: formData.fromDate
      ? dayjs.tz(formData.fromDate, 'America/New_York').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      : null,
    toDate: formData.toDate
      ? dayjs.tz(formData.toDate, 'America/New_York').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      : null,
    message: message && message.trim() ? message.trim() : null,
  };
  if (selectedPolicyId) {
    const selectedPolicy = (selected_customer_list || []).find(
      (p) => p.id === selectedPolicyId
    );

    if (selectedPolicy) {
      formattedData.policyId = selectedPolicy.id;
    }
  } else {
    formattedData.clientCustomerId = customerId;
  }
  dispatch(searchNoteAction(formattedData));
  setHasSearched(true);
};

  const resetSearch = () => {
    setHasSearched(false);
    // setFromDate(dayjs().startOf('month'));
    // setToDate(dayjs());
    setFormData({
      fromDate: formatForForm(getFirstOfMonth()),
      toDate: formatForForm(getToday()),
    });
    setMessage("");
    setFieldErrors({});
    setTouchedFields({});
    reset({
      fromDate: null,
      toDate: null,
      userId: "",
      message: "",
      searchPolicy: "",
    });
  };

  return (
    <>
      {showNote ? (
        <FormProvider {...methods}>
          <AddNotes
            setShowNote={setShowNote}
            setShowButton={showButton}
            newpolicyId={newpolicyId}
            customerId={customerId}
            />
          <AddNotesTable
            setSearchPerformed={setSearchPerformed}
            getPolicyNumber={getPolicyNumber}
            notesPolicyId={notesPolicyId}
            notes={notes}
            hasSearched={hasSearched}
            customerId={customerId}
            selectedOption={selectedOption}
            selectedPolicyId={selectedPolicyId}
            selected_customer_list={selected_customer_list}
          />
        </FormProvider>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "flex-start",
              mb: 2,
              padding: "0 20px",
              boxSizing: "border-box",
            }}
          >
            <Box
              sx={{
                width: "225px",
                height: "50px",
                marginTop: "-30px",
              }}
            >
              <Typography variant="body1" sx={{ mb: 0.5, ...poppinsFont }}>
                From
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePickerField
                  fieldName="fromDate"
                  formData={formData}
                  handleDateChange={handleDateChange}
                  handleBlur={handleBlur}
                  touchedFields={touchedFields}
                  fieldErrors={fieldErrors}
                />
              </LocalizationProvider>
            </Box>

            <Box
              sx={{
                width: "225px",
                height: "50px",
                marginTop: "-30px",
              }}
            >
              <Typography variant="body1" sx={{ mb: 0.5, ...poppinsFont }}>
                To
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePickerField
                  fieldName="toDate"
                  formData={formData}
                  handleDateChange={handleDateChange}
                  handleBlur={handleBlur}
                  touchedFields={touchedFields}
                  fieldErrors={fieldErrors}
                />
              </LocalizationProvider>
            </Box>

            <Box
              sx={{
                width: "225px",
                height: "50px",
                marginTop: "-30px",
              }}
            >
              <Typography variant="body1" sx={{ mb: 0.5, ...poppinsFont }}>
                Search
              </Typography>
              <TextField
                sx={{
                  ...poppinsFont,
                  width: "225px",
                  "& .MuiInputBase-root": {
                    height: "56px",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& input": { height: "100%" },
                }}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                size="small"
                placeholder="Enter search term..."
              />
            </Box>

            <Box>
              <Button
                onClick={onSubmit}
                variant="outlined"
                size="large"
                sx={{marginTop: "30px",}}
              >
                Search
              </Button>
            </Box>

            <Box>
              <Button
                onClick={resetSearch}
                variant="outlined"
                size="large"
                sx={{marginTop: "30px",}}
              >
                Reset
              </Button>
            </Box>

            <Box sx={{ marginTop: "30px", }}>
              <AddNoteButton handleClick={handleClick} />
            </Box>
          </Box>
          <Box
            sx={{
              height:
                fieldErrors.fromDate || fieldErrors.toDate ? "10px" : "0px",
              transition: "height 0.3s ease",
            }}
          />

          <Box sx={{ marginTop: 2 }}>
            <AddNotesTable
              notes={hasSearched ? searchNotes : notes}
              getPolicyNumber={getPolicyNumber}
              notesPolicyId={notesPolicyId}
              hasSearched={hasSearched}
              customerId={customerId}
              selectedOption={selectedOption}
              selectedPolicyId={selectedPolicyId}
              selected_customer_list={selected_customer_list}
            />
          </Box>
        </>
      )}
    </>
  );
};

export default PoliciesList;